import {
  Box,
  Card,
  CardContent, Grid, makeStyles, TextField
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import IconButton from "@material-ui/core/IconButton";
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { history } from 'src/utils/utils';
import CompanyService from '../../../services/company/company.service';

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  DividerPosition: {
    position: "relative",
    top: "-25px",
    marginLeft: "48px"
  },
  IconBackground: {
    background: "#fff"
  },
  boxborder: {
    height: "150px",
    width: "50%",
    border: "1px solid gainsboro",
    margin: "8px",
    padding: "0px 10px 5px 15px",
    borderRadius: "10px"
  },
  h1: {
    width: "101px",
    marginTop: "-12px",
    marginLeft: "24px",
    background: "#f4f6f8",
    fontsize: "1px"

  },
  CardSize: {
    height: "120px",
    background: "#4688f0",
    color: "#fff",
  },
  TextPosition: {
    position: "relative",
    // top: "54px",
    fontSize: "13px"
  }
}));

const Toolbar = ({ className, filterRfp, sortRfp, sortOrder, filterRfpApi, ...rest }) => {

  const [showCompanyInformation, setShowCompanyInformation] = React.useState(0);
  const [showProductInformation, setShowProductInformation] = React.useState(0);
  const [companyId, setCompanyId] = useState(null);

  const classes = useStyles();
  const companyService = new CompanyService();
  useEffect(() => {
    getCompanyData()
  }, []);
  useEffect(() => {
    if (companyId) {
      getProductData()
    }
  }, [companyId])

  useEffect(() => {
  }, [showProductInformation])
  /*const filterRfpApi = (e) => {
    alert(e.target.value)
  }*/

  const getCompanyData = () => {
    companyService.getCompanyByUser(false).then(
      res => {
        if (res !== undefined && res) {
          setShowCompanyInformation(res?.company?.companyName && res?.company?.companyName !== '' ? 1 : 0)
          if (res?.company?._id) {
            setCompanyId(res.company._id);
          }
        }
      }
    ).catch((err) => console.log(':: err', err))
  }

  const getProductData = () => {
    companyService.getProductList(companyId, 1, 10).then(
      res => {
        if (res !== undefined && res) {
          setShowProductInformation(res?.data && res?.data?.length !== 0 ? 1 : 0)
        }
      }
    ).catch(err => console.log(':: err', err))
  }

  const redirectToRFP = () => {
    history.push('/app/create-rfp');
  }
  return (
    <div
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Box
        display="flex"
        justifyContent="flex-end"
      >

      </Box>

      {
        (showCompanyInformation === 0 || showProductInformation === 0) ? (
          <Box className={classes.boxborder}>
            <h6 className={classes.h1}> TO-DO</h6>
            <Grid container spacing={3}>
              {
                showCompanyInformation === 0 ? (
                  <Grid item xs={6} sm={3}>
                    <Card onClick={() => history.push({
                      pathname: '/app/additional-information',
                      state: {
                        step: 0
                      }
                    })} className={classes.CardSize}>
                      <CardContent style={{ padding: '0px' }}>
                        <center>
                          <img src="/company.png" style={{ height: '75px' }} />
                        </center>
                        <Typography className={classes.TextPosition} align="center" variant="h6">
                          Add Company information
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ) : null
              }
              {
                showProductInformation === 0 ? (<Grid item xs={6} sm={3}>
                  <Card onClick={() => history.push({
                    pathname: '/app/additional-information',
                    state: {
                      step: 1
                    }
                  })} className={classes.CardSize}>
                    <CardContent style={{ padding: '0px' }}>
                      <center><img src="/product.png" style={{ height: '75px' }} /></center>
                      <Typography className={classes.TextPosition} align="center" variant="h6">
                        Add Product
                        <br /> information
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>) : null
              }
            </Grid>


          </Box>
        ) : null
      }


      <Tooltip title="Create RFP">
        <IconButton className={classes.IconBackground} onClick={redirectToRFP} style={{ "marginTop": "5px" }} color="primary" type="button" variant="contained">
          <AddIcon />
        </IconButton>
      </Tooltip>
      <Divider className={classes.DividerPosition} varient="fullWidth" />
      <div  >
        <Grid style={{ marginTop: "10px" }} container spacing={3}>
          <Grid spacing={3} md={2} item sm={2} xs={2}>
            <TextField
              fullWidth
              label="Filter"
              name="companyType"
              select
              SelectProps={{ native: true }}
              variant="outlined"
              onChange={(e) => filterRfpApi(e)}
            >
              <option value='all'>all</option>
              <option value='completed'>Response Submitted</option>
              {/*<option value='inprogress'>In-Progress</option>*/}
              <option value='respondrfp'>Respond To RFP</option>
              <option value='updaterfp'>Update RFP</option>
              <option value='rfpdashboard'>Live RFP</option>
              <option value='rfpCompleted'>Completed RFP</option>
              <option value='declined'>Declined</option>
            </TextField>

          </Grid>
          <Grid spacing={3} md={2} item sm={2} xs={2}>
            <TextField
              fullWidth
              label="Sort"
              name="companyType"
              select
              SelectProps={{ native: true }}
              variant="outlined"
              onChange={(e) => sortRfp(e)}
            >
              <option key='Select' value='Select'>Select</option>
              <option value='title'>Title</option>
              <option value='createddate'>Create Date</option>
              <option value='publishdate'>Publish Date</option>

            </TextField>
          </Grid>
          <Grid spacing={3} md={2} item sm={2} xs={2}>

            <Typography component="div">
              <Grid component="label" container alignItems="center" spacing={1}>
                <Grid item>Desc</Grid>
                <Grid item>
                  <Switch onChange={(e) => sortOrder(e)}></Switch>
                </Grid>
                <Grid item>Asc</Grid>
              </Grid>
            </Typography>

          </Grid>

        </Grid>


      </div>

    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string
};

export default Toolbar;
